//export const REGISTER_NEWSLETTER = "REGISTER_NEWSLETTER";
// error
export const SHOW_ERROR = 'SHOW_ERROR';
// loading
export const SHOW_LOADING = 'SHOW_LOADING';
// navigation
export const SET_IS_BACK = 'SET_IS_BACK';
export const SET_LAST_SHAFT_TAB = 'SET_LAST_SHAFT_TAB';
// auth
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const SAVE_CREDENTIALS = 'SAVE_CREDENTIALS';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
// user
export const SAVE_USER = 'SAVE_USER';
// sites
export const SAVE_SITES = 'SAVE_SITES';
export const SAVE_MY_SITES = 'SAVE_MY_SITES';
export const SAVE_SITE = 'SAVE_SITE';
// shafts
export const SAVE_SHAFTS = 'SAVE_SHAFTS';
export const SAVE_SHAFT = 'SAVE_SHAFT';
export const SAVE_SELECT_CHOICES = 'SAVE_SELECT_CHOICES';
// orders
export const SET_ORDERS = 'SET_ORDERS';
// search
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
